import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var Member = t.type({
  id: t.string,
  name: t.string,
  title: nullable(t.string),
  company: nullable(t.string),
  avatarUrl: nullable(t.string)
});
export var HTML = t.type({
  html: t.string,
  text: t.string
});
var Response = t.type({
  answer: t.string,
  question: HTML,
  answerType: t.keyof({
    Image: null,
    ConvertedVideo: null,
    BrokenVideo: null,
    RawVideo: null,
    File: null,
    Text: null
  })
});
export var Comment = t.type({
  id: t.string,
  createdAt: nullable(t.string),
  body: t.string,
  member: Member,
  currentUserLike: nullable(t.type({
    id: t.string
  })),
  likes: nullable(t.type({
    totalCount: t.number
  }))
});
export var Comments = t.type({
  edges: nullable(t.array(t.type({
    cursor: t.string,
    node: Comment
  }))),
  pageInfo: t.type({
    hasNextPage: t["boolean"],
    endCursor: t.string
  }),
  totalCount: t.number
});
export var PublicResponseComments = t.type({
  node: nullable(t.type({
    id: t.string,
    comments: nullable(Comments)
  }))
});
export var PublicResponse = t.type({
  __typename: t.literal('PublicResponse'),
  id: t.string,
  createdAt: t.string,
  member: Member,
  responses: nullable(t.array(Response)),
  comments: nullable(t.type({
    totalCount: t.number
  })),
  currentUserLike: nullable(t.type({
    id: t.string
  })),
  // likes: nullable(t.type({ totalCount: t.number })),
  hidden: t["boolean"]
});
export var PublicResponses = t.type({
  edges: nullable(t.array(t.type({
    cursor: t.string,
    node: nullable(PublicResponse)
  }))),
  pageInfo: nullable(t.type({
    hasNextPage: t["boolean"],
    endCursor: t.string
  })),
  totalCount: t.number
});
export var PublicResponseStageOutput = t.type({
  node: t.type({
    id: t.string,
    publicResponses: nullable(PublicResponses)
  })
});
export var PublicResponseWithStage = t.type({
  __typename: t.literal('PublicResponse'),
  id: t.string,
  stage: t.type({
    id: t.string
  })
});
export var PublicResponseCommentWithStage = t.type({
  __typename: t.literal('PublicResponseComment'),
  id: t.string,
  publicResponse: t.type({
    id: t.string,
    stage: t.type({
      id: t.string
    })
  })
});
export var ResponseOrComment = t.type({
  node: nullable(t.union([PublicResponseWithStage, PublicResponseCommentWithStage]))
});